<template>
  <div>
    <div class="editlink">
      <Form ref="formValidate" :model="formValidate" :rules="ruleInline" :label-width="100">
        <FormItem label="内容来源:">
          <Tag v-if="tag" closable @on-close="TagClose">{{tag}}</Tag>
          <Dropdown trigger="click" placement="bottom-start" @on-click="selectLink">
            <a href="javascript:void(0)">
              选择要跳转的页面
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="0">自定义</DropdownItem>
              <DropdownItem name="1">公司</DropdownItem>
              <!-- <Dropdown placement="right-start">
                <DropdownItem name="2">
                    产品分组
                    <Icon type="ios-arrow-forward"></Icon>
                </DropdownItem>
                <DropdownMenu slot="list">
                  <DropdownItem 
                  style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" 
                  v-for="(item,index) of proGroupList"
                  :key="'proGroup' + index"
                  @click.native="selectProGroup(item)"
                  >
                  {{item.name}}
                </DropdownItem>
                </DropdownMenu>
              </Dropdown> -->
              <Dropdown placement="right-start">
                <DropdownItem name="3">
                    产品
                    <Icon type="ios-arrow-forward"></Icon>
                </DropdownItem>
                <DropdownMenu slot="list">
                  <DropdownItem 
                  style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" 
                  v-for="(item,index) of proList"
                  :key="'pro' + index"
                  @click.native="selectPro(item)"
                  >
                  {{item.name}}
                </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Dropdown placement="right-start">
                <DropdownItem name="4">
                    品牌
                    <Icon type="ios-arrow-forward"></Icon>
                </DropdownItem>
                <DropdownMenu slot="list">
                  <DropdownItem 
                  style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" 
                  v-for="(item,index) of brandList"
                  :key="'brand' + index"
                  @click.native="selectBrand(item)"
                  >
                  {{item.name}}
                </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <DropdownItem name="5">动态</DropdownItem>
            </DropdownMenu>
            <!-- <DropdownMenu slot="list">
              <DropdownItem
                v-for="(item, index) in linkArr"
                :key="index"
                @click.native="selectType(item)"
              >{{item.label}}</DropdownItem>
            </DropdownMenu> -->
          </Dropdown>
        </FormItem>
        <!-- <FormItem label="显示条数:" v-show="type === '2'">
          <Select v-model="linkItem.Count">
            <Option v-for="item in num" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem> -->
        <FormItem label="链接名称:" v-show="linkItem.type === '0'">
          <Input v-model="linkItem.name" />
        </FormItem>
        <FormItem label="链接地址:" v-show="linkItem.type === '0'" prop="link">
          <Input v-model="formValidate.link" placeholder="请输入链接地址" />
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    linkItem: {
      type: Object,
      default: function() {
        return {
          type: "", // 外链相关类型  (0:自定义,1:公司，2:产品分组，3:产品，4:品牌,5:商机)
          name: "",
          url: "",
          Count: ""
        }
      }
    },
  },
  model: {
    prop: 'linkItem',
    event: 'sendlinkItem'
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
  },
  data() {
    const that = this;
    const urlReg = (rule, value, callback) => {
      if (value !== false) {
        if (!that.formValidate.link) {
          callback("外链地址不能为空");
        }
        if (/(https):\/\/([\w.]+\/?)\S*/.test(that.formValidate.link)) {
          this.linkItem.url = this.formValidate.link;
          this.$emit('popperHide');
          callback();
        } else {
          callback("请输入正确的外链地址");
        }
      } else {
        callback();
      }
    };
    return {
      proGroupList: null,
      proList: null,
      brandList: null,
      // type: "",
      tag: "",
      linkArr: [
        {
          label: "自定义",
          value: 0
        },
        {
          label: "公司",
          value: 1
        },
        {
          label: "产品分组",
          value: 2
        },
        {
          label: "产品",
          value: 3
        },
        {
          label: "品牌",
          value: 4
        },
        {
          label: "商机",
          value: 5
        }
      ],
      num: [
        {
          value: '1',
          label: '1条'
        },
        {
          value: '2',
          label: '2条'
        },
        {
          value: '3',
          label: '3条'
        },
        {
          value: '4',
          label: '4条'
        },
        {
          value: '5',
          label: '5条'
        },
      ],
      name: "",
      url: "",

      formValidate: {
        link: ""
      },
      ruleInline: {
        link: [{ validator: urlReg, trigger: "change" }]
      },
    }
  },
  methods: {
    ...mapActions({
      getProduct: "productModule/getProduct",
      getBrand: "companyModule/getBrand",
      getProductGroup: "productModule/getProductGroup",
    }),
    async init() {
      // 产品分组列表
      let proGroupList = await this.getProductGroup({ "CompId": this.company.id });
      let proGroupList2 = await this.getProductGroup({ "CompId": this.company.id, "pageSize": proGroupList.totalCount });
      this.proGroupList = proGroupList2.items;
      // 产品列表
      let proList = await this.getProduct({ "CompId": this.company.id });
      let proList2 = await this.getProduct({ "CompId": this.company.id, "pageSize": proList.totalCount });
      this.proList = proList.items;
      // 品牌列表
      let brandList = await this.getBrand({ "CompId": this.company.id });
      let brandList2 = await this.getBrand({ "CompId": this.company.id, "pageSize": brandList.totalCount });
      this.brandList = brandList2.items;
      if (this.linkItem.type) {
        switch(this.linkItem.type){
          case '0':
            this.tag = '自定义';
            this.formValidate.link = this.linkItem.url;
            break;
          case '1':
            this.tag = '公司';
            break;
          case '3':
            this.tag = '产品 | ';
            this.proList.map(c => {
              if (this.linkItem.url === c.id) {
                this.tag = `产品 | ${c.name}`;
              }
            })
            break;
          case '4':
            this.tag = '品牌';
            this.brandList.map(c => {
              if (this.linkItem.url === c.id) {
                this.tag = `品牌 | ${c.name}`;
              }
            })
            break;
          case '5':
            this.tag = '动态';
            break;
        }
      }
    },
    selectLink(value) {
      if(value === "0") {
        this.tag = "自定义";
        this.linkItem.type = "0";
        this.linkItem.name = ""
      }
      if(value === "1") {
        this.tag = "公司";
        this.linkItem.type = "1";
        this.linkItem.name = "公司";
        this.linkItem.url = this.company.id;
      }
      if(value === "5") {
        this.tag = "动态";
        this.linkItem.type = "5";
        this.linkItem.name = "动态";
        this.linkItem.url = this.company.id;
      }
      this.$emit('popperHide');
    },
    selectProGroup(item) {
      this.tag = `产品分组 | ${item.name}`;
      this.linkItem.type = "2";
      this.linkItem.name = item.name;
      this.linkItem.url = item.id;
      this.linkItem.Count = 10;
    },
    selectPro(item) {
      this.tag = `产品 | ${item.name}`;
      this.linkItem.type = "3";
      this.linkItem.name = item.name;
      this.linkItem.url = item.id;
      this.$emit('popperHide')
    },
    selectBrand(item) {
      this.tag = `品牌 | ${item.name}`;
      this.linkItem.type = "4";
      this.linkItem.name = item.name;
      this.linkItem.url = item.id;
      this.$emit('popperHide')
    },
    TagClose() {
      this.tag = "";
      // this.type = "";
      this.linkItem.type = "";
      this.linkItem.name = "";
      this.linkItem.url = "";
      this.$emit('popperHide');
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="scss" scoped>
.editlink {
  border:dashed 1px #dbd4d4;
  padding: 20px 30px 0;
  margin-bottom: 20px;
}
</style>